/**
 * Step buttons snap to multiples of `step` for case-pack-style stepping
 * (integer step >= 2) so values like `13` with `step=4` land on the grid
 * (↑ → 16, ↓ → 12) instead of drifting (13 + 4 = 17). Typing remains
 * unrestricted; only the buttons snap. For `step` < 2 or non-integer step,
 * falls back to the original "add/subtract step" behavior so callers with
 * currency steps (0.01, 0.1) and `step="any"` are unchanged.
 */
export function snapIncrement(current: number, step: number): number {
  if (!shouldSnap(step)) {
    return current + step;
  }
  if (current % step === 0) {
    return current + step;
  }
  return Math.ceil(current / step) * step;
}

export function snapDecrement(current: number, step: number): number {
  if (!shouldSnap(step)) {
    return current - step;
  }
  if (current % step === 0) {
    return current - step;
  }
  return Math.floor(current / step) * step;
}

function shouldSnap(step: number): boolean {
  return Number.isInteger(step) && step >= 2;
}
